<template>
  <div>
    <button type="button" class="btn btn-warning rounded-0 btn-sm mb-3" @click="toggleScale">
      Cambiar a escala {{ nextScale }}
    </button>
    <div ref="chart" title="statistics chart"></div>
  </div>
</template>

<script>
import Highcharts from 'highcharts';
import {onMounted, ref, watch, computed} from "vue";
import {colorSeriesBlocksChart} from "@/utils/utils";
import router from "@/router";
import {useRoute} from "vue-router";
import {useI18n} from "vue-i18n";


export default {
  name: "ChartByTypeBlocks",
  components: {

  },

  props: {
    facetes: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, { emit }) {

    const { t } = useI18n();
    const route = useRoute();

    const nextScale = computed(() => isLogarithmic.value ? 'Lineal' : 'Logarítmica');
    const isLogarithmic = ref(false);
    const chart = ref(null);
    const chartOptions = ref({
      chart: {
        type: 'column',
        //zoomType: 'y',
        style: {
          fontFamily: 'Roboto'
        }
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: ['Tipus de material']
      },
      yAxis: {
        type: 'linear',
      },
      plotOptions: {
        column: {
          pointPadding: 0,
          groupPadding: 0,
          pointWidth: 80, // <--- fuerza el ancho de cada columna
          borderWidth: 0
        },
        series: {
          dataLabels: {
            enabled: false,
            rotation: 0,
          },
          groupPadding: 0,
          cursor: 'pointer',
          /*point: {
            events: {
              click: (event => {
                handlePointClick(event)
              })
            }
          }*/
        },
      },
      legend: {
        itemStyle: {
          fontWeight: 'bold',
        }
      },
      //colors: ['#2f7ed8', '#0d233a', '#8bbc21', '#910000', '#1aadce', '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
      colors: [],
      series: []
    });



    onMounted(async () => {


    });

    watch(() => props.facetes, (newFacetes, oldFacetes) => {

      chartOptions.value.title.text = t('Activitats docents per ambit')
      // Solo ejecuta la lógica si newFacetes es diferente de oldFacetes
      if (JSON.stringify(newFacetes) !== JSON.stringify(oldFacetes)) {
        if(newFacetes.subtipus !== undefined) {

          let newSeries = []

          let allFacetes = []
          let total = 0;

          //PUBLICACIONS DOCENTS
          for (let i = 1; i < newFacetes.subtipus.length; i += 2) {
            total += newFacetes.subtipus[i];
          }
          if(total > 0) allFacetes.push("subtipus", total)


          //DOCENCIA
          total = 0;
          for (let i = 1; i < newFacetes.activitat_subtipus_docencia.length; i += 2) {
            total += newFacetes.activitat_subtipus_docencia[i];
          }
          if(total > 0) allFacetes.push("activitat_subtipus_docencia", total)

          //FORMACIO
          total = 0;
          for (let i = 1; i < newFacetes.activitat_subtipus_formacio.length; i += 2) {
            total += newFacetes.activitat_subtipus_formacio[i];
          }
          if(total > 0) allFacetes.push("activitat_subtipus_formacio", total)

          //TUTORIA
          total = 0;
          for (let i = 1; i < newFacetes.activitat_subtipus_tutoria.length; i += 2) {
            total += newFacetes.activitat_subtipus_tutoria[i];
          }
          if(total > 0) allFacetes.push("activitat_subtipus_tutoria", total)

          //INNOVACIO
          total = 0;
          for (let i = 1; i < newFacetes.activitat_subtipus_innovacio.length; i += 2) {
            total += newFacetes.activitat_subtipus_innovacio[i];
          }
          if(total > 0) allFacetes.push("activitat_subtipus_innovacio", total)

          //PREMIS
          total = 0;
          for (let i = 1; i < newFacetes.activitat_subtipus_premis.length; i += 2) {
            total += newFacetes.activitat_subtipus_premis[i];
          }
          if(total > 0) allFacetes.push("activitat_subtipus_premis", total)


          /*allFacetes = newFacetes.subtipus
              //.concat(newFacetes.activitat_subtipus_docencia.filter(item => item.value !== "assignaturesImpartidas")
              .concat(newFacetes.activitat_subtipus_docencia)
              .concat(newFacetes.activitat_subtipus_formacio)
              .concat(newFacetes.activitat_subtipus_tutoria)
              .concat(newFacetes.activitat_subtipus_innovacio)
              .concat(newFacetes.activitat_subtipus_premis)*/

          for (let i = 0; i < allFacetes.length; i += 2) {

            let typeSerie
            // Asignar tipo de serie según el índice i
            if (i < newFacetes.subtipus.length) {
              typeSerie = 'subtipus';
            }

            const name = allFacetes[i];
            const value = allFacetes[i + 1];

            //console.log(name + " ---------------- " + typeSerie)

            newSeries.push({'name': t(name), 'data': [value], color: colorSeriesBlocksChart(name), typeSerie: typeSerie})
          }


          chartOptions.value.series = newSeries;

          if(chartOptions.value.xAxis.categories.length <= 10){
            chartOptions.value.plotOptions.series.pointWidth = 40
          }

          if (chart.value) {
            Highcharts.chart(chart.value, chartOptions.value);
          }
        }
      }



    }, { immediate: true });


    const handlePointClick = async (event) => {
      //alert(event.point.series.name+': '+event.point.y +' - '+  event.point.category);

      // Param SUBTIPUS or ACTIVITAT_SUBTIPUS_FORMACIO, ACTIVITAT_SUBTIPUS_INNOVACIO, etc.
      let filterName = event.point.series.options.typeSerie
      let filterValue = event.point.series.name

      let currentQuery = { ...route.query };
      // Verificar si el filtro ya existe y si tiene múltiples valores
      if (currentQuery[filterName]) {
        const existingValues = currentQuery[filterName].split(',');
        // Añadir el nuevo valor si no existe ya en la lista
        if (!existingValues.includes(filterValue)) {
          currentQuery[filterName] = [...existingValues, filterValue].join(',');
        }
      } else {
        // Si no existe, simplemente añadirlo
        currentQuery[filterName] = filterValue;
      }


      await router.push({
        name: route.name,
        params: {
          page: route.params.page,
          sort: route.params.sort,
          ...(route.params.id !== undefined && { id: route.params.id }) // Añadir el parámetro 'id' solo si no es 'undefined'
        },
        query: {...currentQuery} // Mantener los parámetros actuales (modificados) de la URL
      });

      // Emitir el evento con los nuevos parámetros
      emit('apply-filter', { query: currentQuery });
      //await getMaterials(currentPage.value, store.getters.pageSize, query.value, route.params.sort, route.query)
    };


    const toggleScale = () => {
      isLogarithmic.value = !isLogarithmic.value;
      chartOptions.value.yAxis.type = isLogarithmic.value ? 'logarithmic' : 'linear';
      Highcharts.chart(chart.value, chartOptions.value);
    };




    return {
      handlePointClick,
      toggleScale,
      chartOptions,
      chart,
      nextScale
    }
  }
}
</script>
